<template>
  <div class="modal fade" id="customEventModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalLabel">
            <slot name="header">Default Header</slot>
          </h5>
          <button class="close" type="button" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-html="bodyHtml">
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" type="button" data-bs-dismiss="modal">Back</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminEventModal',
  props: {
    bodyHtml: {
      type: String,
      default: ''
    },
  },
};
</script>
